
import React from 'react'
import { use, api, app } from 'xadmin'
import { C } from 'xadmin-ui'
import { Spin, Radio } from 'antd';
import _ from 'lodash';

const NODE_TYPES = ['string', 'number', 'boolean']
const TYPES = { 'Number': '数字', 'Boolean': '布尔值', 'String': '字符串', 'Object': '对象', 'Array': '数组' }


const LogicEditor = props => {
  const { permissions } = use('redux', state => ({ permissions: state.user && state.user.permissions }))
  const { value, onChange, tags, model, loading, systemVar, systemLoading } = props

  const renderProps = (s, prefix) => {
    if (s && s.properties) {
      return Object.keys(s.properties).reduce((prev, key) => {
        const p = s.properties[key]
        if (p.type == 'object' && p.properties) {
          const ps = renderProps(p, prefix + key + '.')
          if (Object.keys(ps).length > 0) {
            prev[p.title || p.name || key] = ps
          }
        } else if (NODE_TYPES.indexOf(p.type) >= 0) {
          prev[p.title || p.name || key] = prefix + key
        }
        return prev
      }, {})
    }
    return {}
  }

  const systemVarRender = (value, prefix, item) => {
    return Object.keys(value).reduce((prev, cur) => {
      if (_.isObject(value[cur])) {
        prev[cur + ` prefix:${TYPES[getType(value[cur])] || ''}`] = systemVarRender(value[cur], prefix + cur + '.', item)
      } else {
        const str = (prefix + cur).replace(/systemVar./, 'prefix:')
        prev[cur + `${str} -- ${TYPES[getType(value[cur])] || ''}`] = prefix + cur
      }
      return prev
    }, {})
  }

  const getType = (item) => Object.prototype.toString.apply(item).slice(8, -1);

  const getData = (tags, schema) => {
    let data = {
      '数据点': tags ? tags.reduce((p, t) => { p[t.name] = 'var.' + t.id; return p }, {}) : {},
      '资产属性': renderProps(schema, 'node.'),
    }
    if (permissions.length == 0 || permissions && permissions.indexOf('systemvariable') > -1) {
      data['数据字典'] = systemVar ? systemVar.reduce((p, t) => {
        if (_.isObject(t.value)) {
          p[t.name + `prefix:${t.uid} -- ${TYPES[getType(t.value)] || ''}`] = systemVarRender(t.value, 'systemVar.' + t.uid + '.', t)
        } else {
          p[t.name + `prefix:${t.uid} -- ${TYPES[getType(t.value)] || ''}`] = 'systemVar.' + t.uid
        }
        return p
      }, {}) : {}
    }
    return data
  }

  return (loading && systemLoading) ? <Spin /> :
    (<C is="Model.ExtendsModel" name="Node" data={{ model }}>
      {schema => (
        <C is="Form.LogicEditor"
          data={getData(tags, schema)}
          value={value || {}}
          onChange={onChange}
        />
      )}
    </C>)

}

const ModelLogicEditor = props => (
  <C is="TagWrap" nodeId={props.nodeId} modelId={props.model.id}>
    {state => <LogicEditor {...props} {...state} />}
  </C>
)

const JsLogic = (props) => {
  const { value, onChange, tags, model, loading, systemVar } = props

  const tagsToSchema = (tags) => {
    const properties = {}
    for (let tag of tags) {
      properties[tag.id] = {
        title: tag.name,
        type: 'object',
        nodeType: 'tag',
        properties: {
          online: {
            title: '在线状态',
            type: 'boolean'
          }
        }
      }
    }
    return properties
  }
  const systemVarToSchema = (tags) => {
    const properties = {}
    for (let tag of tags) {
      properties[tag.id] = {
        title: tag.name,
        type: tag.type
      }
    }
    return properties
  }

  const getSchema = (schema, tags) => {
    const result = {
      type: 'object',
      properties: {
        tags: {
          title: '数据点',
          type: 'object',
          properties: tagsToSchema(tags)
        },
        '#$node': {
          title: '资产属性',
          type: 'object',
          properties: schema.properties
        },
        '#$systemVariable': {
          title: '数据字典',
          type: 'object',
          properties: systemVarToSchema(systemVar)
        }
      }
    }
    return result
  }

  const customStringify = (item, elementStringify) => {
    if (item?.variable?.path?.substr(0, 4) === 'tags') {
      const result = `{{${item.variable.path.substr(5, item.variable.path.length)}}}`
      if (result.indexOf('online') !== -1) {
        return result.replace('.', '_@')
      } else {
        return result
      }
    } else {
      return elementStringify(item)
    }
  }

  return (
    <C is="Model.ExtendsModel" name="Node" data={{ model }}>
      {schema => {
        console.log(schema, 'schema')
        return <C 
          is="CodeEditor.VariableEditor"
          isFormula={true}
          value={value}
          onChange={onChange}
          schema={getSchema(schema, tags)}
          customStringify={customStringify}
          style={{ backgroundColor: '#f0f2f5', padding: '4px 11px' }}
        />
      }}
    </C>
  )
}

const JsLogicEditor = props => (
  <C is="TagWrap" nodeId={props.nodeId} modelId={props.model.id}>
    {state => <JsLogic {...props} {...state} />}
  </C>
)

const ModelLogicField = ({ input, field: { nodeId, option, resultType } }) => {

  const [ type, setType ] = React.useState(input?.value?.type || 'formulaLogic')

  const [systemVar, setSystemVar] = React.useState([])
  const [systemLoading, setsystemLoading] = React.useState(false)

  React.useEffect(() => {
    api({ name: 'core/systemVariable' }).query({ fields: ['icon', 'value', 'type'] }, {})
      .then(({ items }) => {
        setSystemVar(items)
        setsystemLoading(true)
      })
    // }
  }, [])

  const onChange = (v) => {
    try {
      const val = JSON.parse(JSON.stringify(v))
      const payload = { type }
      if (type === 'jsLogic') {
        payload.jsLogic = val.stringify
        payload.origin = val.origin
      } else {
        payload.logic = val
      }
      input.onChange(payload)
    } catch (err) {
      console.log(err)
      input.onChange(v)
    }
  }

  return (
    <div>
      <Radio.Group value={type} buttonStyle="solid" onChange={(e) => { setType(e.target.value) }} style={{ marginBottom: '10px' }}>
        <Radio.Button value="formulaLogic">编辑器</Radio.Button>
        <Radio.Button value="jsonlogic">选择器</Radio.Button>
        <Radio.Button value="jsLogic">js编辑器</Radio.Button>
      </Radio.Group>
      {
        type === 'jsonlogic' ? (
          <div onClick={input.onBlur}>
            <ModelLogicEditor
              value={input?.value?.type ? input?.value?.logic : input.value}
              onChange={onChange}
              nodeId={nodeId}
              model={option.form.data}
              resultType={resultType || 'any'}
              systemVar={systemVar}
              systemLoading={systemLoading}
            />
          </div>
        ) : null
      }
      {
        type === 'formulaLogic' ? (
          <C is="CodeEditor.ModelLogicEditor"
            width="100%"
            height={40}
            ignoreParentKeys={['aggregations', 'selectors', 'transformations', 'predictors', 'technicalAnalysis']}
            value={input?.value?.type ? input?.value?.logic : input.value}
            onChange={({ value }) => { onChange(value) }}
            model={option.form.data}
            nodeId={nodeId}
          />
        ) : null
      }
      {
        type === 'jsLogic' ? (
          <JsLogicEditor
            value={input?.value?.type === 'jsLogic' ? {origin: input?.value?.origin, stringify: input?.value?.jsLogic} : null}
            onChange={onChange}
            nodeId={nodeId}
            model={option.form.data}
            systemVar={systemVar}
          />
        ) : null
      }
      
    </div>
  )
}

export default ModelLogicEditor
export {
  ModelLogicField
}
